/**
 * Session and timeout constants
 * Centralized configuration for session management
 */

// Time of inactivity before showing the timeout warning (5 minutes)
export const INACTIVITY_TIMEOUT = 5 * 60 * 1000;

// Duration the warning dialog is shown before auto-logout (5 minutes)
// Total time from last activity to auto-logout = INACTIVITY_TIMEOUT + WARNING_DURATION = 10 minutes.
// ACC-07 (Phase 2): one timer for every user type, guardians included. The total must not exceed 10 minutes.
export const WARNING_DURATION = 5 * 60 * 1000;

// Upper bound for INACTIVITY_TIMEOUT + WARNING_DURATION (enforced by unit test)
export const MAX_SESSION_IDLE = 10 * 60 * 1000;

// Development mode - shorter timeouts for testing (set to true to test with 30s timeouts)
export const DEV_MODE = false;

// Development timeout values
export const DEV_INACTIVITY_TIMEOUT = 30000; // 30 seconds
export const DEV_WARNING_DURATION = 30000; // 30 seconds

// Activity events to track for session management
export const ACTIVITY_EVENTS = [
  'mousedown',
  'mousemove',
  'keypress',
  'scroll',
  'touchstart',
  'click',
] as const;

// Get effective timeout values based on mode
export const getSessionTimeouts = () => {
  if (DEV_MODE) {
    return {
      inactivityTimeout: DEV_INACTIVITY_TIMEOUT,
      warningDuration: DEV_WARNING_DURATION,
    };
  }
  return {
    inactivityTimeout: INACTIVITY_TIMEOUT,
    warningDuration: WARNING_DURATION,
  };
};
